import React from 'react'
import useBreakpoint from '~/hooks/useBreakpoint'
import {Breakpoint, ExternalLinks} from '~/types/constEnums'

import Menu from './Menu'
import MenuItem from './MenuItem'
import MenuItemWithIcon from './MenuItemWithIcon'







const TopBarHelpMenu = (props) => {
  const {menuProps, toggleShortcuts, dataCy} = props
  const isDesktop = useBreakpoint(Breakpoint.SIDEBAR_LEFT)
  const gotoSupport = () => {
    window.open(ExternalLinks.SUPPORT, '_blank', 'noreferrer')
  }
  const gotoContact = () => {
    window.open(ExternalLinks.CONTACT, '_blank', 'noreferrer')
  }
  return (
    React.createElement(Menu, { ariaLabel: 'How may we help?', ...menuProps,}
      , React.createElement(MenuItem, {
        label: React.createElement(MenuItemWithIcon, { dataCy: `${dataCy}`, label: 'Documentation', icon: 'bookmark',} ),
        onClick: gotoSupport,}
      )
      , isDesktop && (
        React.createElement(MenuItem, {
          label: 
            React.createElement(MenuItemWithIcon, { dataCy: `${dataCy}`, label: 'Keyboard Shortcuts', icon: 'keyboard',} )
          ,
          onClick: toggleShortcuts,}
        )
      )
      , React.createElement(MenuItem, {
        label: React.createElement(MenuItemWithIcon, { dataCy: `${dataCy}`, label: 'Get help', icon: 'comment',} ),
        onClick: gotoContact,}
      )
    )
  )
}

export default TopBarHelpMenu
